import React from 'react';
import { useTranslation } from 'react-i18next';
import usePublicStats from '../../hooks/usePublicStats';

const Regulations = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';
  // Q7 — server-counted, not a literal. See usePublicStats.
  const { warningLetters, stats, fmt } = usePublicStats();
  // The FTC card said "OTC Monograph 3,455건 학습" — wrong on BOTH counts.
  // Nothing counted 3,455, and the artifact is not monographs: a monograph
  // is a CFR part (333, 347, 348, 352 …) and there are on the order of a
  // dozen. What we actually hold is 22,566 OTC DRUG LABEL records. Now
  // server-counted and named for what it is.
  const otcRecords = stats?.otc_label_records ?? null;
  const otcBadgeKo = otcRecords != null
    ? `OTC 표시·라벨 데이터 ${fmt(otcRecords)}건 학습`
    : 'OTC 표시·라벨 데이터 학습';
  const otcBadgeEn = otcRecords != null
    ? `${fmt(otcRecords)} OTC drug label records learned`
    : 'Trained on OTC drug label records';
  const wlBadgeKo = warningLetters != null
    ? `Warning Letters ${fmt(warningLetters)}건 학습`
    : 'Warning Letters 학습';
  const wlBadgeEn = warningLetters != null
    ? `${fmt(warningLetters)} Warning Letters learned`
    : 'Trained on FDA Warning Letters';

  const regulators = [
    {
      flag: '🇰🇷',
      name: 'MFDS',
      descKo: '식품의약품안전처',
      descEn: 'Ministry of Food and Drug Safety',
      codeKo: '화장품법, 기능성화장품 심사 규정',
      codeEn: 'Korean Cosmetics Act',
      badgeKo: "지원 준비 중 ('27 상반기)",
      badgeEn: 'Coming H1 2027'
    },
    {
      flag: '🇺🇸',
      name: 'FDA',
      descKo: 'U.S. Food & Drug Administration',
      descEn: 'U.S. Food & Drug Administration',
      codeKo: 'FD&C Act, MoCRA',
      codeEn: 'FD&C Act, MoCRA',
      badgeKo: wlBadgeKo,
      badgeEn: wlBadgeEn
    },
    {
      flag: '🇺🇸',
      name: 'FTC',
      descKo: 'Federal Trade Commission',
      descEn: 'Federal Trade Commission',
      codeKo: 'Truth in Advertising',
      codeEn: 'Truth in Advertising',
      badgeKo: otcBadgeKo,
      badgeEn: otcBadgeEn
    }
  ];

  return (
    <section style={{ padding: '72px 0' }}>
      <div className="wrap">
        <div className="section-head">
          <h2>{isKo ? '신뢰할 수 있는' : 'Built on trusted'}</h2>
          <h3>{isKo ? '글로벌 규제 가이드라인' : 'global regulatory guidance'}</h3>
          <p>{isKo ? '각 국가 규제 기관의 공식 데이터를 기반으로 정확한 검증을 제공합니다' : 'Validation is grounded in official regulatory sources and structured compliance data.'}</p>
        </div>
        <div className="grid-3">
          {regulators.map((r, i) => (
            <div key={i} className="card reg-card">
              <h4>{r.flag} {r.name}</h4>
              <p>{isKo ? r.descKo : r.descEn}</p>
              <div className="code">{isKo ? r.codeKo : r.codeEn}</div>
              <span className="data-badge">{isKo ? r.badgeKo : r.badgeEn}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Regulations;
